const getters = {

    getInvoiceNumber(state) {

        return state.invoiceNumber;
    }

}
export default getters;